var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDineIn = function SvgDineIn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 4.167v41.666M21.85 19h15.635M21.85 29h15.635M13.5 44.833V5.167h29.208a3.17 3.17 0 0 1 3.167 3.166v33.334a3.17 3.17 0 0 1-3.167 3.166H13.5Z",
    stroke: "#73AB54",
    strokeWidth: 2
  })));
};
export default SvgDineIn;